<template>
  <div class="c-record-detail">
    <!-- info -->
    <div class="c-info">
      <Form class="c-form-wrap" :label-width="90" inline>
        <FormItem label="素材ID：">
          <span>{{ imageId }}</span>
        </FormItem>
        <FormItem label="素材名称：">
          <span>{{ imageName }}</span>
        </FormItem>
        <FormItem label="设计人：">
          <span>{{ designerName }}</span>
        </FormItem>
        <FormItem label="上传时间：">
          <span>{{ imageCreateTime }}</span>
        </FormItem>
      </Form>
    </div>
    <!-- table -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <design-detail-table :height="tableHeight" :loading="loading" :data="tableList" :columns="columns" />
        <Page
          show-total
          show-elevator
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          size="small"
          class="c-table-page pager"
          @on-change="changePageIndex"
        />
      </Viewport>
    </div>
  </div>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/design_detail_column'
import { isArray, formatDate } from '@/common/js/utils'
import { getDesignDetailList } from '@/api/manage.model'
import DesignDetailTable from './components/design-detail-table'

export default {
  name: 'recordDetail',
  mixins: [mixin],
  components: { DesignDetailTable },
  methods: {
    getData() {
      const month = formatDate(new Date(this.imageCreateTime), 'yyyy-MM')
      this.$Spin.show()
      getDesignDetailList({
        page_id: this.pageIndex,
        page_size: this.pageSize,
        reportMonth: month,
        imageId: this.imageId
      })
        .then((data) => {
          this.$Spin.hide()
          if (data) {
            const { list, page_info } = data
            if (isArray(list) && page_info) {
              const { total_number } = page_info
              this.tableList = list
              this.total = total_number || 0
            }
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    }
  },
  data() {
    const { id, name, designer, upload } = this.$route.query
    return {
      tableHeight: 330,
      imageCreateTime: decodeURI(upload),
      imageId: id,
      imageName: decodeURI(name),
      designerName: decodeURI(designer),
      columns
    }
  },
  created() {
    this.getData()
  }
}
</script>
<style lang="scss" scoped>
.c-record-detail {
  height: 100%;

  .c-info {
    width: 100%;
    padding: 0;
    display: flex;
    background-color: #ffffff;
    margin-bottom: 8px;

    .ivu-form-item {
      margin-bottom: 8px;
      margin-right: 60px;
      text-align: left;
    }

    .c-form-wrap {
      display: inline-block;
      background-color: rgb(242, 242, 242);
      width: 100%;
      .ivu-form-item {
        margin-bottom: 0;
      }
    }
  }

  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
